exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/** Colors */\n/** FlatUI Color Palette\n*\n*\tColor names based on FlatUI: https://flatuicolors.com/\n*/\n/** Acrylic Color Palette\n*\n*\tColor names based on Name that Color: http://chir.ag/projects/name-that-color\n*/\n.remove-btn .btn:hover {\n  color: #da3232; }\n\n.remove-btn button[disabled].btn {\n  color: #888888; }\n\n.remove-btn button[disabled].btn:hover {\n  color: #888888; }\n\n.remove-btn button[disabled].btn:active {\n  color: #888888; }\n\n.remove-btn .remove-button-content {\n  color: #da3232;\n  font-weight: 600; }\n  .remove-btn .remove-button-content:hover {\n    text-decoration: underline; }\n", ""]);

// exports
